/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { PtwRegistrationState } from './PtwRegistrationState';
import {
    PtwRegistrationStateFromJSON,
    PtwRegistrationStateFromJSONTyped,
    PtwRegistrationStateToJSON,
} from './PtwRegistrationState';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { CoordinateSystem } from './CoordinateSystem';
import {
    CoordinateSystemFromJSON,
    CoordinateSystemFromJSONTyped,
    CoordinateSystemToJSON,
} from './CoordinateSystem';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { CalibrationDataDtoCalibrationState } from './CalibrationDataDtoCalibrationState';
import {
    CalibrationDataDtoCalibrationStateFromJSON,
    CalibrationDataDtoCalibrationStateFromJSONTyped,
    CalibrationDataDtoCalibrationStateToJSON,
} from './CalibrationDataDtoCalibrationState';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { Brand } from './Brand';
import {
    BrandFromJSON,
    BrandFromJSONTyped,
    BrandToJSON,
} from './Brand';
import type { QaEquipmentStateOfUse } from './QaEquipmentStateOfUse';
import {
    QaEquipmentStateOfUseFromJSON,
    QaEquipmentStateOfUseFromJSONTyped,
    QaEquipmentStateOfUseToJSON,
} from './QaEquipmentStateOfUse';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { DeviceInterfaceType } from './DeviceInterfaceType';
import {
    DeviceInterfaceTypeFromJSON,
    DeviceInterfaceTypeFromJSONTyped,
    DeviceInterfaceTypeToJSON,
} from './DeviceInterfaceType';
import type { SingleDetectorConnectorType } from './SingleDetectorConnectorType';
import {
    SingleDetectorConnectorTypeFromJSON,
    SingleDetectorConnectorTypeFromJSONTyped,
    SingleDetectorConnectorTypeToJSON,
} from './SingleDetectorConnectorType';
import type { WithSerialNumber } from './WithSerialNumber';
import {
    WithSerialNumberFromJSON,
    WithSerialNumberFromJSONTyped,
    WithSerialNumberToJSON,
} from './WithSerialNumber';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { IotDeviceStateOfUse } from './IotDeviceStateOfUse';
import {
    IotDeviceStateOfUseFromJSON,
    IotDeviceStateOfUseFromJSONTyped,
    IotDeviceStateOfUseToJSON,
} from './IotDeviceStateOfUse';

/**
 * 
 * @export
 * @interface UnicheckSimulatorDto
 */
export interface UnicheckSimulatorDto {
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof UnicheckSimulatorDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnicheckSimulatorDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnicheckSimulatorDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnicheckSimulatorDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckSimulatorDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof UnicheckSimulatorDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof UnicheckSimulatorDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof UnicheckSimulatorDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof UnicheckSimulatorDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof UnicheckSimulatorDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof UnicheckSimulatorDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof UnicheckSimulatorDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckSimulatorDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof UnicheckSimulatorDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {number}
     * @memberof UnicheckSimulatorDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckSimulatorDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof UnicheckSimulatorDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof UnicheckSimulatorDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckSimulatorDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    defaultImageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    masterDeviceId?: string | null;
    /**
     * 
     * @type {WithSerialNumber}
     * @memberof UnicheckSimulatorDto
     */
    withSerialNumber?: WithSerialNumber;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {Brand}
     * @memberof UnicheckSimulatorDto
     */
    brand1?: Brand;
    /**
     * 
     * @type {SingleDetectorConnectorType}
     * @memberof UnicheckSimulatorDto
     */
    singleDetectorConnectorType?: SingleDetectorConnectorType;
    /**
     * 
     * @type {DeviceInterfaceType}
     * @memberof UnicheckSimulatorDto
     */
    deviceInterfaceType?: DeviceInterfaceType;
    /**
     * 
     * @type {QaEquipmentSubCategory}
     * @memberof UnicheckSimulatorDto
     */
    subCategory: QaEquipmentSubCategory;
    /**
     * 
     * @type {CoordinateSystem}
     * @memberof UnicheckSimulatorDto
     */
    coordinateSystem?: CoordinateSystem;
    /**
     * 
     * @type {QaEquipmentStateOfUse}
     * @memberof UnicheckSimulatorDto
     */
    state?: QaEquipmentStateOfUse;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckSimulatorDto
     */
    isRegistrable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckSimulatorDto
     */
    isCalibratable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    serialNumber: string;
    /**
     * 
     * @type {PtwRegistrationState}
     * @memberof UnicheckSimulatorDto
     */
    registrationState?: PtwRegistrationState;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    registrationTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    deRegistrationTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    measurementDataChannelId?: string;
    /**
     * 
     * @type {IotDeviceStateOfUse}
     * @memberof UnicheckSimulatorDto
     */
    iotDeviceStateOfUse?: IotDeviceStateOfUse;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckSimulatorDto
     */
    hasValidLicense?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    licenseExpirationDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    calibrationCertificateNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    calibrationDate?: string | null;
    /**
     * 
     * @type {CalibrationDataDtoCalibrationState}
     * @memberof UnicheckSimulatorDto
     */
    calibrationState?: CalibrationDataDtoCalibrationState | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckSimulatorDto
     */
    $type?: UnicheckSimulatorDtoTypeEnum;
}


/**
 * @export
 */
export const UnicheckSimulatorDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoUnicheckSimulatorDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.UnicheckSimulatorDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UnicheckSimulatorDtoTypeEnum = typeof UnicheckSimulatorDtoTypeEnum[keyof typeof UnicheckSimulatorDtoTypeEnum];



/**
 * Check if a given object implements the UnicheckSimulatorDto interface.
 */
export function instanceOfUnicheckSimulatorDto(value?: unknown): value is UnicheckSimulatorDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UnicheckSimulatorDtoTypeEnum)[0];
}

export function UnicheckSimulatorDtoFromJSON(json: any): UnicheckSimulatorDto {
    return UnicheckSimulatorDtoFromJSONTyped(json, false);
}

export function UnicheckSimulatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnicheckSimulatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': json['editingUser'] == null ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': json['editingTime'] == null ? undefined : json['editingTime'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': json['isReferenced'] == null ? undefined : json['isReferenced'],
        'isReferencedBy': json['isReferencedBy'] == null ? undefined : ((json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'deleterUserId': json['deleterUserId'] == null ? undefined : json['deleterUserId'],
        'deletionTime': json['deletionTime'] == null ? undefined : json['deletionTime'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'name': json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'typeSpecification': json['typeSpecification'] == null ? undefined : json['typeSpecification'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': json['subModel'] == null ? undefined : json['subModel'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'defaultImageId': json['defaultImageId'] == null ? undefined : json['defaultImageId'],
        'masterDeviceId': json['masterDeviceId'] == null ? undefined : json['masterDeviceId'],
        'withSerialNumber': json['withSerialNumber'] == null ? undefined : WithSerialNumberFromJSON(json['withSerialNumber']),
        'typeNumber': json['typeNumber'] == null ? undefined : json['typeNumber'],
        'brand1': json['brand1'] == null ? undefined : BrandFromJSON(json['brand1']),
        'singleDetectorConnectorType': json['singleDetectorConnectorType'] == null ? undefined : SingleDetectorConnectorTypeFromJSON(json['singleDetectorConnectorType']),
        'deviceInterfaceType': json['deviceInterfaceType'] == null ? undefined : DeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'subCategory': QaEquipmentSubCategoryFromJSON(json['subCategory']),
        'coordinateSystem': json['coordinateSystem'] == null ? undefined : CoordinateSystemFromJSON(json['coordinateSystem']),
        'state': json['state'] == null ? undefined : QaEquipmentStateOfUseFromJSON(json['state']),
        'isRegistrable': json['isRegistrable'] == null ? undefined : json['isRegistrable'],
        'isCalibratable': json['isCalibratable'] == null ? undefined : json['isCalibratable'],
        'serialNumber': json['serialNumber'],
        'registrationState': json['registrationState'] == null ? undefined : PtwRegistrationStateFromJSON(json['registrationState']),
        'registrationTime': json['registrationTime'] == null ? undefined : json['registrationTime'],
        'deRegistrationTime': json['deRegistrationTime'] == null ? undefined : json['deRegistrationTime'],
        'measurementDataChannelId': json['measurementDataChannelId'] == null ? undefined : json['measurementDataChannelId'],
        'iotDeviceStateOfUse': json['iotDeviceStateOfUse'] == null ? undefined : IotDeviceStateOfUseFromJSON(json['iotDeviceStateOfUse']),
        'hasValidLicense': json['hasValidLicense'] == null ? undefined : json['hasValidLicense'],
        'licenseExpirationDate': json['licenseExpirationDate'] == null ? undefined : json['licenseExpirationDate'],
        'calibrationCertificateNumber': json['calibrationCertificateNumber'] == null ? undefined : json['calibrationCertificateNumber'],
        'calibrationDate': json['calibrationDate'] == null ? undefined : json['calibrationDate'],
        'calibrationState': json['calibrationState'] == null ? undefined : CalibrationDataDtoCalibrationStateFromJSON(json['calibrationState']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function UnicheckSimulatorDtoToJSON(value?: Omit<UnicheckSimulatorDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'possibleActions'|'deleterUserId'|'deletionTime'|'isDeleted'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'commentCount': value['commentCount'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'lastComment': value['lastComment'],
        'isAvailable': value['isAvailable'],
        'origin': EntityOriginToJSON(value['origin']),
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        'lastModifierUser': UserCatalogDtoToJSON(value['lastModifierUser']),
        'editingUser': UserCatalogDtoToJSON(value['editingUser']),
        'editingTime': value['editingTime'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value['isReferenced'],
        'isReferencedBy': value['isReferencedBy'] == null ? undefined : ((value['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoToJSON)),
        'name': value['name'],
        'iuid': value['iuid'],
        'description': value['description'],
        'typeSpecification': value['typeSpecification'],
        'category': RtSystemCategoryToJSON(value['category']),
        'manufacturer': RtSystemManufacturerToJSON(value['manufacturer']),
        'model': value['model'],
        'subModel': value['subModel'],
        'imageId': value['imageId'],
        'isArchived': value['isArchived'],
        'defaultImageId': value['defaultImageId'],
        'masterDeviceId': value['masterDeviceId'],
        'withSerialNumber': WithSerialNumberToJSON(value['withSerialNumber']),
        'typeNumber': value['typeNumber'],
        'brand1': BrandToJSON(value['brand1']),
        'singleDetectorConnectorType': SingleDetectorConnectorTypeToJSON(value['singleDetectorConnectorType']),
        'deviceInterfaceType': DeviceInterfaceTypeToJSON(value['deviceInterfaceType']),
        'subCategory': QaEquipmentSubCategoryToJSON(value['subCategory']),
        'coordinateSystem': CoordinateSystemToJSON(value['coordinateSystem']),
        'state': QaEquipmentStateOfUseToJSON(value['state']),
        'isRegistrable': value['isRegistrable'],
        'isCalibratable': value['isCalibratable'],
        'serialNumber': value['serialNumber'],
        'registrationState': PtwRegistrationStateToJSON(value['registrationState']),
        'registrationTime': value['registrationTime'],
        'deRegistrationTime': value['deRegistrationTime'],
        'measurementDataChannelId': value['measurementDataChannelId'],
        'iotDeviceStateOfUse': IotDeviceStateOfUseToJSON(value['iotDeviceStateOfUse']),
        'hasValidLicense': value['hasValidLicense'],
        'licenseExpirationDate': value['licenseExpirationDate'],
        'calibrationCertificateNumber': value['calibrationCertificateNumber'],
        'calibrationDate': value['calibrationDate'],
        'calibrationState': CalibrationDataDtoCalibrationStateToJSON(value['calibrationState']),
        '$type': value['$type'],
    });
}

